namespace TabAurous.OMS {
    export interface ProcessInspectionRow {
        Id?: number;
        TemplateId?: number;
        ProcessId?: number;
        Parameter?: string;
        Value?: string;
        IsNumeric?: boolean;
        Min?: number;
        Max?: number;
    }

    export namespace ProcessInspectionRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Parameter';
        export const localTextPrefix = 'OMS.ProcessInspection';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            TemplateId = "TemplateId",
            ProcessId = "ProcessId",
            Parameter = "Parameter",
            Value = "Value",
            IsNumeric = "IsNumeric",
            Min = "Min",
            Max = "Max"
        }
    }
}
